import styled from 'styled-components';
import { fromMd } from '../../../../constants/breakpoints';
import { deriveTextEmbroideryFontFamilyFromStyle } from '../../utils';
export const Body = styled.div `
  color: ${o => o.color.toLowerCase()};
  font-family: ${o => deriveTextEmbroideryFontFamilyFromStyle(o.$fontStyle)};
  font-size: clamp(8px, 2vw, 32px);
  font-weight: bold;
  position: absolute;
  text-align: center;
  white-space: nowrap;
  z-index: ${o => o.theme.zIndex.foregroundContent};
  will-change: filter;

  ${fromMd} {
    font-size: clamp(8px, 1vw, 32px);
  }
  ${o => o.$warning === 'dark'
    ? `border: 1px dashed #FFC500; padding: ${o.theme.spacing(1)}; background: rgb(from ${o.theme.color.fill.caution.subtle} r g b / 0.3); border-radius: 2px;`
    : o.$warning === 'light'
        ? `border: 1px dashed ${o.theme.color.stroke.caution.text.on.background}; padding: ${o.theme.spacing(1)}; background: rgb(from ${o.theme.color.fill.caution.subtle} r g b / 0.3); border-radius: 2px;`
        : null}
`;
export const Text = styled.span `
  display: block;
`;
//# sourceMappingURL=styles.js.map